// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2swee","productName":"Table_productName__1655n"};